export const treasureEmblem = (
  ctx: CanvasRenderingContext2D,
  thumbOverColor: string,
  thumbToWristColor: string,
  stitchColor: string,
  x: number,
  y: number,
  scaleSize: number
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = thumbOverColor
  ctx.save()
  ctx.scale(scaleSize, scaleSize)
  ctx.beginPath()
  ctx.moveTo(454 + x, 472 + y) // 左上
  ctx.quadraticCurveTo(439 + x, 479 + y, 436 + x, 490 + y) //
  ctx.quadraticCurveTo(449 + x, 499 + y, 449 + x, 499 + y) //
  ctx.quadraticCurveTo(474 + x, 475 + y, 504 + x, 470 + y) //
  ctx.quadraticCurveTo(445 + x, 525 + y, 470 + x, 575 + y) // 左下
  ctx.quadraticCurveTo(510 + x, 600 + y, 587 + x, 496 + y) // 右下＿右上1
  ctx.quadraticCurveTo(586 + x, 480 + y, 586 + x, 480 + y) // 右下＿右上2
  ctx.quadraticCurveTo(537 + x, 528 + y, 537 + x, 528 + y) // 右下の左上
  ctx.quadraticCurveTo(539 + x, 497 + y, 570 + x, 450 + y) //
  ctx.quadraticCurveTo(605 + x, 435 + y, 638 + x, 394 + y) // 右上の右下
  ctx.quadraticCurveTo(555 + x, 433 + y, 540 + x, 435 + y) //
  ctx.quadraticCurveTo(454 + x, 472 + y, 454 + x, 472 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // 下地部分
  ctx.fillStyle = thumbToWristColor
  ctx.beginPath()
  ctx.moveTo(510 + x, 485 + y) // 左上
  ctx.quadraticCurveTo(469 + x, 534 + y, 483 + x, 554 + y) //
  ctx.quadraticCurveTo(494 + x, 537 + y, 510 + x, 485 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // // 下地部分
  ctx.beginPath()
  ctx.moveTo(547 + x, 465 + y) //
  ctx.quadraticCurveTo(530 + x, 475 + y, 530 + x, 475 + y) //
  ctx.quadraticCurveTo(500 + x, 555 + y, 495 + x, 555 + y) //
  ctx.quadraticCurveTo(515 + x, 550 + y, 518 + x, 545 + y) //
  ctx.quadraticCurveTo(528 + x, 498 + y, 547 + x, 465 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // ステッチここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(439 + x, 488 + y) //
  ctx.quadraticCurveTo(448 + x, 495 + y, 450 + x, 495 + y) //
  ctx.quadraticCurveTo(482 + x, 465 + y, 510 + x, 468 + y) //
  ctx.quadraticCurveTo(444 + x, 527 + y, 475 + x, 575 + y) //

  ctx.moveTo(499 + x, 453 + y) //
  ctx.quadraticCurveTo(576 + x, 430 + y, 632 + x, 399 + y) //
  ctx.quadraticCurveTo(593 + x, 440 + y, 568 + x, 446 + y) //
  ctx.quadraticCurveTo(532 + x, 502 + y, 534 + x, 535 + y) //
  ctx.quadraticCurveTo(584 + x, 487 + y, 584 + x, 485 + y) // 右上1
  ctx.quadraticCurveTo(584 + x, 494 + y, 584 + x, 497 + y) // 右上2
  ctx.quadraticCurveTo(559 + x, 530 + y, 531 + x, 555 + y) //
  // //
  ctx.moveTo(512 + x, 481 + y) //
  ctx.quadraticCurveTo(465 + x, 528 + y, 481 + x, 560 + y) //
  ctx.quadraticCurveTo(504 + x, 525 + y, 512 + x, 481 + y) //
  // // //
  ctx.moveTo(491 + x, 560 + y) // 左下
  ctx.quadraticCurveTo(505 + x, 560 + y, 520 + x, 550 + y) //
  ctx.quadraticCurveTo(525 + x, 514 + y, 552 + x, 460 + y) //
  ctx.quadraticCurveTo(525 + x, 475 + y, 528 + x, 475 + y) //
  ctx.quadraticCurveTo(503 + x, 538 + y, 491 + x, 560 + y) //
  // // ステッチここまで
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.restore()
}
